import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { MainRoutes } from '@routes';
import LoginLayout from '@main/login/LoginLayout';
import Login from '@main/login/Login';
import AuthService from '@services/AuthService';

export default function LoginPage() {
  const router = useRouter();

  useEffect(() => {
    if (AuthService.isAuthenticated()) {
      router.push(MainRoutes.home);
    }
  }, []);

  return <Login />;
}

LoginPage.getLayout = function getLayout(page) {
  return <LoginLayout>{page}</LoginLayout>;
};
